import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

/**
 * @deprecated This icon is going to be removed in the future
 * Please use the ArrowForward as an alternative
 */

const ArrowRightIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M11.845 2.138a.5.5 0 0 0-.69.724l9.093 8.638H2.5a.5.5 0 0 0 0 1h17.748l-9.092 8.637a.5.5 0 0 0 .688.726l10-9.5a.5.5 0 0 0 0-.726l-10-9.5Z" />
  </IconWrapper>
)

export default ArrowRightIconMedium
